import React, { useMemo } from 'react';

import { EXPORT_STEPS } from '../../constants/export.constants';
import FooterButtons from '../FooterButtons';

const ExportFooter = ({
  exportStep,
  onCancel,
  onPreview,
  onExport,
  onDownload,
  onStartNew,
  selectedResultRows,
  handleBackButton,
  isLoading,
  onCheckIn,
  isCancelExportProcess,
  isPackagesExport,
}) => {
  const buttons = useMemo(() => {
    switch (exportStep) {
      case EXPORT_STEPS.INITIAL_STEP:
        return [
          { label: 'Cancel', onClick: onCancel },
          { label: 'Preview', variant: 'primary', onClick: onPreview, disabled: isLoading },
        ];
      case EXPORT_STEPS.START_EXPORT:
        return isPackagesExport
          ? [
              { label: 'Cancel', onClick: onCancel },
              { label: 'Back', onClick: handleBackButton },
              {
                label: 'Export',
                variant: 'primary',
                onClick: onExport,
                disabled: !selectedResultRows.size || isLoading,
              },
            ]
          : [
              { label: 'Cancel', onClick: onCancel },
              { label: 'Back', onClick: handleBackButton },
              { label: 'Check In', variant: 'primary', onClick: onCheckIn },
              {
                label: 'Export',
                variant: 'primary',
                onClick: onExport,
                disabled: !selectedResultRows.size || isLoading,
              },
            ];
      case EXPORT_STEPS.EXPORT_COMPLETED:
        return [
          { label: 'Cancel', onClick: onCancel },
          !isCancelExportProcess && { label: 'Download', variant: 'primary', onClick: onDownload },
          { label: 'Start New Export', variant: 'primary', onClick: onStartNew },
        ].filter(Boolean);
      default:
        return [{ label: 'Cancel', onClick: onCancel }];
    }
  }, [
    exportStep,
    onCancel,
    onPreview,
    isLoading,
    handleBackButton,
    onCheckIn,
    isPackagesExport,
    onExport,
    selectedResultRows.size,
    isCancelExportProcess,
    onDownload,
    onStartNew,
  ]);

  return <FooterButtons buttons={buttons} />;
};

export default ExportFooter;
